<template>
    <section>
        <publications-table v-bind:publicaciones="this.publicaciones" :hide-update="true" :cargoPrincipal="cargoPrincipal" :personId="personId"
            @updatePublications="updatePublications" />
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import axios from 'axios'
import PublicationsTable from "../publications/publications_table.vue"
import moment from 'moment'
export default {
    props: [
        'personId', 'cargoPrincipal', 'minYear', 'maxYear', 'changeFilter'
    ],
    components: {
        PublicationsTable
    },
    data(){
        return {
            publicaciones: [],
            isLoading: false,
            year: new Date().getFullYear(),
        }
    },
    async created() {
        await this.getPublications()
    },
    methods: {
        async getPublications() {
            this.isLoading = true
            await axios
                .get('/people/my-magazine-publications.json', {
                    params: {
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        id: this.personId,
                    }
                })
                .then(response => {
                    this.publicaciones = response.data
                    this.publicaciones = this.publicaciones.map(publication => {
                        publication.publication_date = moment(publication.publication_date, ['YYYY-MM-DD', 'DD-MM-YYYY'])
                        return publication
                    })
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        updatePublications(year) {
            this.year = year
            this.getPublications()
        }
    },
    watch: {
        changeFilter: function() {
            this.getPublications()
        }
    }

}
</script>